
import 'jquery'
import 'bootstrap'
import * as ko from "knockout"
import { Globals } from "./Globals";
import { ElementLocationViewModel } from "./ElementLocationViewModel";
import { LabelElementViewModel } from "./elements/LabelElementViewModel";
import { FieldElementViewModel } from "./elements/FieldElementViewModel";
import { DroppedPictureElementViewModel } from "./elements/DroppedPictureElementViewModel";
import { AccountViewModel } from "./AccountViewModel"
import { StylesViewModel } from './elements/StylesViewModel';
import { PhantomViewModel } from './PhantomViewModel';

class DraggedElement {
    viewModel: ElementLocationViewModel;
    draggedControl: HTMLElement;

    constructor(viewModel: ElementLocationViewModel, draggedControl: HTMLElement) {
        this.viewModel = viewModel;
        this.draggedControl = draggedControl;
    }
}

class Main {
    draggedElement: DraggedElement;
    numberOfElements: number;

    constructor(public accountViewModel: AccountViewModel) {
        this.numberOfElements = 0;
        var self = this;

        $(() => {
            $(".element").each((index: number, element: HTMLElement) => {
                $(element).on("dragstart", null, self, this.handleDragStart);
                $(element).on("dragend", this.handleDragEnd);
            });

            $("#canvas td").each((index: number, element: HTMLElement) => {
                var jqElement = $(element);
                jqElement.on("dragleave", this.handleDragLeave);
                jqElement.on("dragenter", this.handleDragEnter)
                jqElement.on("dragover", this.handleDragOver);
                jqElement.on("drop", null, self, this.handleDrop);
                jqElement.attr("data-bind", "attr: { rowspan: rowSpan, colspan: columnSpan }");
            });
        });
    }

    private handleDragStart(e) {
        e.target.style.opacity = .4;
        e.originalEvent.dataTransfer.setData("element-type", $(e.target).data("elementtype"));

        $("#canvas").addClass("canvas-border");
    }

    private handleDragEnd(e) {
        e.target.style.opacity = "";
        $("#canvas").removeClass("canvas-border");
    }

    private handleDragEnter(e) {
        e.target.classList.add("drag-target");
    }

    private handleDragLeave(e) {
        e.target.classList.remove("drag-target");
    }

    private handleDragOver(e) {
        if (e.preventDefault) {
            e.preventDefault();
        }

        return false;
    }

    private reestablishDropTarget(tableCell: HTMLTableCellElement) {
        $(tableCell).attr("rowspan", 1);
        $(tableCell).attr("colspan", 1);
        $(tableCell).on("dragleave", this.handleDragLeave);
        $(tableCell).on("dragenter", this.handleDragEnter)
        $(tableCell).on("dragover", this.handleDragOver);
        $(tableCell).on("drop", null, this, this.handleDrop);
    }

    private createControl(self: Main, dropTarget: any, viewModel: ElementLocationViewModel, controlHtmlClass: string, controlModalId: string) {
        const clonedHtml = $("." + controlHtmlClass).clone();
        $(dropTarget).append(clonedHtml);
        clonedHtml.removeClass(controlHtmlClass);

        let closeButton = clonedHtml.find(".close");
        function removeElement() {
            let parentTableCell = clonedHtml.parent();
            clonedHtml.remove();

            ko.cleanNode(<HTMLTableCellElement>parentTableCell[0]);
            self.numberOfElements--;
            self.reestablishDropTarget(<HTMLTableCellElement>parentTableCell[0]);
        }

        closeButton.click(removeElement);

        self.numberOfElements++;

        clonedHtml.click(() => {
            var originalModal = $("#" + controlModalId);
            var modal = originalModal.clone();

            // Save old values because applyBindings will reset options for <select> elements.
            const oldColumnSpan = viewModel.columnSpan();
            const oldRowSpan = viewModel.rowSpan();
            ko.applyBindings(viewModel, modal[0]);

            viewModel.columnSpan(oldColumnSpan);
            viewModel.rowSpan(oldRowSpan);

            modal.modal();
        });

        clonedHtml.on("dragstart", null, self, (event: any) => {
            event.target.style.opacity = .4;
            let self = event.data as Main;

            self.draggedElement = new DraggedElement(viewModel, event.target);
            event.originalEvent.dataTransfer.setData("element-type", "existing-control");
            if (event.originalEvent.ctrlKey) {
                event.originalEvent.dataTransfer.effectAllowed = "copy";
            }
        });

        clonedHtml.on("dragend", null, self, self.handleDragEnd);

        viewModel.setElementMostLikelyChangedSize(() => {
            var importantContent = clonedHtml.find(".element-controlview-important-content");

            window.setTimeout(function () {
                const height = importantContent[0].offsetHeight;
                const width = importantContent[0].offsetWidth;

                if (height > 0) {
                    viewModel.setRowSpan(Math.ceil(height / Globals.gridSize));
                }

                if (width > 0) {
                    viewModel.setColumnSpan(Math.ceil(width / Globals.gridSize));
                }

                if (height > Globals.maxImageHeight || width > Globals.maxImageWidth) {
                    self.accountViewModel.errorMessage("Images cannot be larger than " + Globals.maxImageHeight + "x" + Globals.maxImageWidth + " pixels.");
                    removeElement();
                }
            }, 500);
        });

        ko.applyBindings(viewModel, dropTarget);
        clonedHtml.show();
    }

    private handleDrop(e) {
        e.preventDefault();

        let self = e.data as Main;
        $(e.target).off("dragleave", self.handleDragLeave);
        $(e.target).off("dragenter", self.handleDragEnter);
        $(e.target).off("dragover", self.handleDragOver);
        $(e.target).off("drop", self.handleDrop);
        $(e.target).removeClass("drag-target");

        const files: FileList = e.originalEvent.dataTransfer.files;
        if (files.length > 0) {
            const file = files[0];
            if (file.type.indexOf("image") == 0) {
                // Place drag'n'drop picture
                let vm = new DroppedPictureElementViewModel("xink-image", self.accountViewModel);
                vm.onImageLoaded = imageSrc => {
                    // If the dropped image is the only control so far
                    // prompt the user if Phantom should be used to convert
                    // the image to HTML.

                    if (self.numberOfElements == 1) {
                        const originalModal = $("#phantom-modal");
                        const modal = originalModal.clone();
                        var image: any = $("img", modal);

                        var phantomVM = new PhantomViewModel(
                            imageSrc,
                            function (json: any, error: string) {
                                if (error === null) {
                                    self.createSignatureFromJson(self, json);
                                }
                                else {
                                    self.accountViewModel.errorMessage(error);
                                }

                                modal.modal("hide");
                            },
                            function () {
                                return image.selectAreas('relativeAreas');
                            });
                        ko.applyBindings(phantomVM, modal[0]);
                        modal.modal();

                        // Image load is not working for some reason. 
                        // Therefore we use a timeout hack.
                        window.setTimeout(function () {
                            if (image.height() > Globals.maxImageHeight || image.width() > Globals.maxImageWidth) {
                                phantomVM.imageSrc(null);
                                self.accountViewModel.errorMessage("Images cannot be larger than " + Globals.maxImageHeight + "x" + Globals.maxImageWidth + " pixels.");
                                modal.modal("hide");
                            }
                            else {
                                image.selectAreas({
                                });
                            }
                        }, 1000);
                    }
                }

                vm.setImage(file);
                self.createControl(self, e.target, vm, "element-controlview-dropped-picture", "element-controlview-dropped-picture-modal");

                return;
            }
        }

        const elementType: string = e.originalEvent.dataTransfer.getData("element-type");
        switch (elementType) {
            case "existing-control":
                let draggedControl = self.draggedElement.draggedControl;
                if (e.originalEvent.dataTransfer.effectAllowed == "copy") {
                    let clonedViewModel = self.draggedElement.viewModel.clone();
                    switch (clonedViewModel.elementType) {
                        case "xink-label":
                            self.createControl(self, e.target, clonedViewModel, "element-controlview-label", "element-controlview-label-modal");
                            break;

                        case "xink-field":
                            self.createControl(self, e.target, clonedViewModel, "element-controlview-field", "element-controlview-field-modal");
                            break;

                        case "xink-image":
                            self.createControl(self, e.target, clonedViewModel, "element-controlview-dropped-picture", "element-controlview-dropped-picture-modal");
                            break;
                    }
                }
                else {
                    let sourceTableCell = $(draggedControl).parent()[0] as HTMLTableCellElement;
                    ko.cleanNode(sourceTableCell);
                    $(e.target).append(draggedControl);
                    ko.applyBindings(self.draggedElement.viewModel, e.target);

                    // Re-establish drop-target for original table cell.
                    self.reestablishDropTarget(sourceTableCell);
                }

                break;

            case "xink-label":
                self.createControl(self, e.target, new LabelElementViewModel(elementType), "element-controlview-label", "element-controlview-label-modal");
                break;

            case "xink-field":
                self.createControl(self, e.target, new FieldElementViewModel(elementType, self.accountViewModel), "element-controlview-field", "element-controlview-field-modal");
                break;

            case "xink-image":
                self.createControl(self, e.target, new DroppedPictureElementViewModel(elementType, self.accountViewModel), "element-controlview-dropped-picture", "element-controlview-dropped-picture-modal");
                break;
        }
    }

    deleteAllElements() {
        const canvas = document.getElementById("canvas") as HTMLTableElement;
        for (let rowIndex = 0; rowIndex < canvas.rows.length; rowIndex++) {
            const row = canvas.rows[rowIndex] as HTMLTableRowElement;
            for (let colIndex = 0; colIndex < row.cells.length; colIndex++) {
                const cell = row.cells[colIndex] as HTMLTableCellElement;

                if (cell.hasChildNodes()) {
                    while (cell.hasChildNodes()) {
                        cell.removeChild(cell.lastChild);
                    }

                    ko.cleanNode(cell);
                    this.reestablishDropTarget(cell);
                }
            }
        }
    }

    createSignatureFromJson(self: Main, jsonModel) {
        self.deleteAllElements();

        const jsonParsed = JSON.parse(jsonModel);

        function setBasicProperties(source: any, vm: ElementLocationViewModel) {
            vm.setColumnSpan(source.ColumnSpan);
            vm.setRowSpan(source.RowSpan);
            vm.isLink(source.IsLink);
            vm.link(source.Link);
        }

        function setStyles(source: any, vm: StylesViewModel) {
            vm.fontFamily(source.FontFamily);
            vm.fontSize(source.FontSize);
            vm.isBold(source.IsBold);
            vm.isItalic(source.IsItalic);
            vm.color(source.Color);
        }

        jsonParsed.forEach(function (element) {
            const canvas = $("#canvas")[0] as HTMLTableElement;
            const td = canvas.rows[element.Row].cells[element.Column] as HTMLTableCellElement;

            switch (element.ViewModel.ElementType) {
                case "xink-label":
                    const vmLabel = new LabelElementViewModel(element.ViewModel.ElementType);

                    vmLabel.text(element.ViewModel.Text);
                    setBasicProperties(element.ViewModel, vmLabel);
                    setStyles(element.ViewModel.Styles, vmLabel.styles());

                    self.createControl(self, td, vmLabel, "element-controlview-label", "element-controlview-label-modal");
                    break;

                case "xink-field":
                    const vmField = new FieldElementViewModel(element.ViewModel.ElementType, self.accountViewModel);
                    setBasicProperties(element.ViewModel, vmField);
                    setStyles(element.ViewModel.Styles, vmField.styles());

                    vmField.field(element.ViewModel.Text);

                    self.createControl(self, td, vmField, "element-controlview-field", "element-controlview-field-modal");
                    break;

                case "xink-image":
                    const vmImage = new DroppedPictureElementViewModel(element.ViewModel.ElementType, self.accountViewModel)
                    setBasicProperties(element.ViewModel, vmImage);

                    vmImage.imageSrc(element.ViewModel.ImageSrc);

                    self.createControl(self, td, vmImage, "element-controlview-dropped-picture", "element-controlview-dropped-picture-modal");
                    break;
            }
        });
    }

    loadSignature() {
        const self = this;
        const callback = metadata => self.createSignatureFromJson(self, metadata);
        this.accountViewModel.loadSignatures(callback);
    }

    saveSignature() {
        this.accountViewModel.saveSignature();
    }
}

const accountViewModel = new AccountViewModel();
let main = new Main(accountViewModel);
const loginElement = $("#login-xink-element");
const notificationArea = $("#notification-area");
const loadSignaturesModal = $("#load-signature-modal");
ko.applyBindings(main, loginElement[0]);
ko.applyBindings(accountViewModel, notificationArea[0]);
ko.applyBindings(accountViewModel, loadSignaturesModal[0]);
window["oauth"] = accountViewModel;



// WEBPACK FOOTER //
// ./code/Site.ts